// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__vwpl0","header":"PatientQuestionnaire_header__3qY4P","info":"PatientQuestionnaire_info__2-4Pm"};